import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/';
import Footer from '../../components/Footer/';

import Colors from '../../views/Theme/Colors/';
import Typography from '../../views/Theme/Typography/';

import AuthService from '../../components/AuthService';
//toast
import { ToastContainer, toast } from 'react-toastify';
import SwaggerUi, { presets } from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';

class Full extends Component {

  constructor() {
    super();
    this.Auth = new AuthService();
  }

  componentWillMount() {
    if (!this.Auth.loggedIn()) {
      this.props.history.replace('/login');
    }

  }

  componentDidMount() {
    let token = this.Auth.getToken();
    this.Auth.httpRequest('GET', 'api/doc').then(function (datas) {
      SwaggerUi({
        dom_id: '#swaggerContainer',
        url: 'https://preproduction.happyquest.co/api/doc',
        requestInterceptor: (req) => {
          req.headers.Authorization = "Bearer " + token;
          return req
        }
      });
    })

  }

  render() {
    return (
      <div className="app">
        <Header />
        <ToastContainer />
        <div className="app-body">
          <Container fluid>
            <div id="swaggerContainer" />
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js